import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import withConfig from '../../context/withConfig';
import withIsMobile from '../../context/withIsMobile';
import { navigateToIntro, toggleChatPanelVisible } from '../../reducers/ui/actions';
import { sendTextMessage } from '../../reducers/history/actions';
import MinimizeIcon from '../icons/MinimizeIcon';
import LeftArrowIcon from '../icons/LeftArrowIcon';

const HeaderWrapper = withIsMobile(styled.div`
  background-color: ${props => props.theme.accentColor};
  padding: 16px;
  padding-bottom: 40px;
  height: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  position: relative;
  z-index: 0; /* Ensure it's below the MessageHistory component */
`);

const BackButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ChatTitle = styled.div`
  font-size: 16px;
  color: white;
  font-weight: 600;
`;

const ChatSubtitle = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
`;

const StyledMinimizeIcon = styled(MinimizeIcon)`
  color: white;
  position: static;
  right: auto;
  top: auto;
`;

export const Avatar = styled.img`
  display: block;
  height: 32px;
  width: 32px;
  border-radius: 8px;

  ${props =>
    props.isSmall &&
    `
    height: 24px;
    width: 24px;
  `};
`;

function Header({ config, nodeRef, navigateToIntro, toggleChatPanelVisible }) {
  const handleClose = () => {
    toggleChatPanelVisible();
  };

  if (config.inline) {
    return null;
  }

  return (
    <HeaderWrapper data-test-id="chatPanelHeader" ref={nodeRef}>
      <BackButton onClick={navigateToIntro}>
        <LeftArrowIcon />
      </BackButton>

      <Avatar src={config.images.header} data-test-id="panelHeaderAvatar" />

      <HeaderContent>
        <ChatTitle>{config.botName || 'Bit'}</ChatTitle>
        <ChatSubtitle>{config.strings.header}</ChatSubtitle>
      </HeaderContent>

      <StyledMinimizeIcon onClick={handleClose} />
    </HeaderWrapper>
  );
}

export default connect(
  state => ({
    inputFieldRef: state.ui.inputFieldRef
  }),
  { navigateToIntro, sendTextMessage, toggleChatPanelVisible }
)(withIsMobile(withConfig(Header)));



// WEBPACK FOOTER //
// ./src/components/Header/index.js